<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-05-06 14:17:24
 * @page： 故障码维护及查询
-->
<template>
    <div class="faultCodeMaintenance">
        <Header :headerData="headerData"></Header>

        <a-select 
            v-if="userInfo.tenant_id == 1"
            class="query_field"
            v-model:value="tenant_id"
            :placeholder="t('account.tenant')"
            :options="tenantOptions"
            style="width: 200px; margin: 40px 10px 10px 0" 
            @change="handleSelectChange('tenant')"
        ></a-select>
        <a-input 
            v-model:value="fault_code" 
            allowClear 
            :placeholder="t('faultData.fault_code')" 
            style="width: 200px; margin: 40px 10px 10px 0" 
            @change="handleInputChange()"
        />

        <div class="operate_btn">
            <a-button type="primary" size="small" style="margin-right:10px;margin-bottom:10px" @click="handle('add')">
                <PlusOutlined />
                {{ $t('base.add') }}
            </a-button>
        </div>

        <!-- 表格 -->
        <Table
            :table="table"
            @handleSearch="handleSearch"
            @handleChangePagination="handleChangePagination"
        >
            <!-- 表格列自定义列内容 -->
            <template v-slot:customCol="{props}">
                <template v-if="props.column.key === 'fault_path'">
                    <div class="fault_path" @click="handle('link',props.record)">
                        <a :href="props.record.fault_path" target="_blank" rel="noopener noreferrer">{{ $t('faultData.link') }}</a>
                    </div>
                </template>
                <!-- <template v-if="props.column.key === 'fault_status' || props.column.key === 'fault_status_de' || props.column.key === 'fault_status_fr' || props.column.key === 'fault_status_nl'">
                    <ul v-if="props.record[props.column.key] != '-'" class="fault_measure_ul" :class="{'fault_measure_ul_more':props.record.showMoreText}">
                        <component v-if="!props.record.showMoreText" :is="$antIcons['DownCircleOutlined']" class="downCircle" @click="props.record.showMoreText = true"></component>
                        <component v-else :is="$antIcons['UpCircleOutlined']" class="downCircle" @click="props.record.showMoreText = false"></component>
                        {{ props.record[props.column.key] }}
                    </ul>
                    <div v-else>-</div>
                </template> -->
                <template v-if="props.column.key === 'fault_limit' || props.column.key === 'fault_limit_de' || props.column.key === 'fault_limit_fr' || props.column.key === 'fault_limit_nl' || props.column.key === 'fault_limit_et' || props.column.key === 'fault_limit_lv' || props.column.key === 'fault_limit_lt'">
                    <ul v-if="props.record[props.column.key] != '-'" class="fault_measure_ul" :class="{'fault_measure_ul_more':props.record.showMoreText}">
                        <component v-if="!props.record.showMoreText" :is="$antIcons['DownCircleOutlined']" class="downCircle" @click="props.record.showMoreText = true"></component>
                        <component v-else :is="$antIcons['UpCircleOutlined']" class="downCircle" @click="props.record.showMoreText = false"></component>
                        <li v-for="(item,index) in props.record[props.column.key]" :key="index">{{ item }}</li>
                    </ul>
                    <div v-else>-</div>
                </template>
                <template v-if="props.column.key === 'fault_measure' || props.column.key === 'fault_measure_de' || props.column.key === 'fault_measure_fr' || props.column.key === 'fault_measure_nl' || props.column.key === 'fault_measure_et' || props.column.key === 'fault_measure_lv' || props.column.key === 'fault_measure_lt'">
                    <ul v-if="props.record[props.column.key] != '-'" class="fault_measure_ul" :class="{'fault_measure_ul_more':props.record.showMoreText}">
                        <component v-if="!props.record.showMoreText" :is="$antIcons['DownCircleOutlined']" class="downCircle" @click="props.record.showMoreText = true"></component>
                        <component v-else :is="$antIcons['UpCircleOutlined']" class="downCircle" @click="props.record.showMoreText = false"></component>
                        <li v-if="props.record[`${props.column.key}_img`] !== ''">
                            <a-image :width="60" :height="22" :src="props.record[`${props.column.key}_img`]"/>
                        </li>
                        <li v-for="(item,index) in props.record[props.column.key]" :key="index">{{ item }}</li>
                    </ul>
                    <div v-else>-</div>
                </template>
            </template>
            <!-- 表格操作按钮 -->
            <template v-slot:tableAction="{props}">
                <template v-if="props.column.key === 'action'">
                    <a-button type="primary" size="small" @click="handle('edit',props.record)">{{$t('base.edit')}}</a-button>
                </template>
            </template>
        </Table>

        <!-- 新增、编辑 -->
        <a-modal
            v-model:visible="addVisible"
            :title="modalTitle"
            :bodyStyle="{ 'height':'80vh','overflow-y':'scroll'}"
            width="870px"
            centered
            :maskClosable="false"
            :okText="$t('base.confirm')"
            :okButtonProps="{disabled:okBtnDisabled}"
            @ok="handle('confirm')"
        >
            <Form 
                :form="addForm"
                @handleAddBtnClick="handleAddBtnClick"
                @handleRemoveBtnClick="handleRemoveBtnClick"
                @uploadChange="uploadChange"
                @uploadRemove="uploadRemove"
            ></Form>
        </a-modal>
    </div>
</template>

<script setup>
    import { onMounted, ref, reactive, toRefs, createVNode, watch, nextTick} from "vue";
    import Table from "@/components/Table.vue";
    import Form from "@/components/Form.vue";
    import Header from "@/layouts/component/Header.vue";
    import UploadImg from "@/components/UploadImg.vue";
    import { FaultCodeAddForm } from './FaultCodeRatioFormConfig.js';
    import { useRouter } from "vue-router";
    import { useI18n } from 'vue-i18n';
    import { message, Modal } from 'ant-design-vue';
    import { FaultApi } from '@/api/FaultApi.js';
    import { AdvancedFunApi } from '@/api/AdvancedFunApi.js';
    import { getWeek } from '@/hooks/useGetWeek';
    // import { debounce } from 'lodash-es';

    const { t } = useI18n()
    const BASE_API_URL = import.meta.env.VITE_BASE_URL

    const userInfo = ref(JSON.parse(sessionStorage.getItem('userInfo')))
    const visible = ref(false)
    const addVisible = ref(false)
    const modalTitle = ref(t('base.add'))
    const delMsg = ref(t('base.delMsg'))
    const addForm =  reactive(JSON.parse(JSON.stringify(FaultCodeAddForm)))
    const copyAddForm =  reactive(JSON.parse(JSON.stringify(FaultCodeAddForm)))
    const rowData = ref(null)
    const operateType = ref('')
    const okBtnDisabled = ref(false)
    const lang = ref(localStorage.getItem('lang')? localStorage.getItem('lang') : '')
    const tenant_id = ref(null)
    const fault_code = ref('')
    const tenantOptions = ref([])

    const table = ref({
        data: [],
        columns: [
            // {
            //     title: t('base.order_number'),  // 序号
            //     dataIndex: 'order_number',
            //     key: 'order_number',
            //     width:70,
            // }, 
            {
                title: t('role.tenant'),  // 租户
                dataIndex: 'sys_org',
                key: 'sys_org',
                width:100,
                resizable: true,
                fixed: 'left',
            },
            {
                title: t('faultData.fault_code'),  // 故障码
                dataIndex: 'fault_code',
                key: 'fault_code',
                width:150,
                resizable: true,
                fixed: 'left',
            }, 
            {
                title: t('faultData.protocol'),  // 协议
                dataIndex: 'protocol',
                key: 'protocol',
                width:100,
                resizable: true,
            }, 
            {
                title: t('faultData.fault_path'),  // 故障页面
                dataIndex: 'fault_path',
                key: 'fault_path',
                width:100,
                resizable: true,
                // ellipsis:true,
            },
            {
                title: t('faultData.fault_status'),  // 故障状态
                dataIndex: 'fault_status',
                key: 'fault_status',
                width:230,
                resizable: true,
                ellipsis:true,
            }, 
            {
                title: t('faultData.fault_limit'), // 故障限制
                dataIndex: 'fault_limit',
                key: 'fault_limit',
                width:230,
                resizable: true,
                ellipsis:true,
            },
            {
                title: t('faultData.fault_measure'), // 故障解决方案
                dataIndex: 'fault_measure',
                key: 'fault_measure',
                width:500,
                resizable: true,
                // ellipsis:true,
            },
            {
                title: t('faultData.fault_status_de'), // 故障状态（德语）
                dataIndex: 'fault_status_de',
                key: 'fault_status_de',
                width:230,
                resizable: true,
                ellipsis:true,
            },
            {
                title: t('faultData.fault_limit_de'),  // 故障限制（德语）
                dataIndex: 'fault_limit_de',
                key: 'fault_limit_de',
                width:230,
                resizable: true,
                ellipsis:true,
            },
            {
                title: t('faultData.fault_measure_de'), // 故障处理措施（德语）
                dataIndex: 'fault_measure_de',
                key: 'fault_measure_de',
                width:500,
                resizable: true,
                // ellipsis:true,
            },
            {
                title: t('faultData.fault_status_fr'), // // 故障状态（法语）
                dataIndex: 'fault_status_fr',
                key: 'fault_status_fr',
                width:230,
                resizable: true,
                ellipsis:true,
            },
            {
                title: t('faultData.fault_limit_fr'), // 故障限制（法语）
                dataIndex: 'fault_limit_fr',
                key: 'fault_limit_fr',
                width:230,
                resizable: true,
                ellipsis:true,
            },
            {
                title: t('faultData.fault_measure_fr'),  // 故障处理措施（法语）
                dataIndex: 'fault_measure_fr',
                key: 'fault_measure_fr',
                width:500,
                resizable: true,
                // ellipsis:true,
            },
            {
                title: t('faultData.fault_status_nl'), // 故障状态（荷兰语）
                dataIndex: 'fault_status_nl',
                key: 'fault_status_nl',
                width:230,
                resizable: true,
                ellipsis:true,
            },
            {
                title: t('faultData.fault_limit_nl'), // 故障限制（荷兰语）
                dataIndex: 'fault_limit_nl',
                key: 'fault_limit_nl',
                width:230,
                resizable: true,
                // ellipsis:true,
            },
            {
                title: t('faultData.fault_measure_nl'),  // 故障处理措施（荷兰语）
                dataIndex: 'fault_measure_nl',
                key: 'fault_measure_nl',
                width:500,
                resizable: true,
                // ellipsis:true,
            },
            {
                title: t('faultData.fault_status_et'), // 故障状态（爱沙尼亚语）
                dataIndex: 'fault_status_et',
                key: 'fault_status_et',
                width:230,
                resizable: true,
                ellipsis:true,
            },
            {
                title: t('faultData.fault_limit_et'), // 故障限制（爱沙尼亚语）
                dataIndex: 'fault_limit_et',
                key: 'fault_limit_et',
                width:230,
                resizable: true,
                // ellipsis:true,
            },
            {
                title: t('faultData.fault_measure_et'),  // 故障处理措施（爱沙尼亚语）
                dataIndex: 'fault_measure_et',
                key: 'fault_measure_et',
                width:500,
                resizable: true,
                // ellipsis:true,
            },
            {
                title: t('faultData.fault_status_lv'), // 故障状态（拉脱维亚语）
                dataIndex: 'fault_status_lv',
                key: 'fault_status_lv',
                width:230,
                resizable: true,
                ellipsis:true,
            },
            {
                title: t('faultData.fault_limit_lv'), // 故障限制（拉脱维亚语）
                dataIndex: 'fault_limit_lv',
                key: 'fault_limit_lv',
                width:230,
                resizable: true,
                // ellipsis:true,
            },
            {
                title: t('faultData.fault_measure_lv'),  // 故障处理措施（拉脱维亚语）
                dataIndex: 'fault_measure_lv',
                key: 'fault_measure_lv',
                width:500,
                resizable: true,
                // ellipsis:true,
            },
            {
                title: t('faultData.fault_status_lt'), // 故障状态（立陶宛语）
                dataIndex: 'fault_status_lt',
                key: 'fault_status_lt',
                width:230,
                resizable: true,
                ellipsis:true,
            },
            {
                title: t('faultData.fault_limit_lt'), // 故障限制（立陶宛语）
                dataIndex: 'fault_limit_lt',
                key: 'fault_limit_lt',
                width:230,
                resizable: true,
                // ellipsis:true,
            },
            {
                title: t('faultData.fault_measure_lt'),  // 故障处理措施（立陶宛语）
                dataIndex: 'fault_measure_lt',
                key: 'fault_measure_lt',
                width:500,
                resizable: true,
                // ellipsis:true,
            },
            {
                title: t('base.operate'),//'操作'
                key: 'action',
                fixed: 'right',
                width: 100,
                resizable: true,
            },
        ],
        configs: {
            table: {
                rowClassName:(record, index) => (index % 2 === 1 ? 'table-striped' : null)
            },
            scroll: {
                x: 800,
                y: 480,//设置表格高度，固定表头
            },
            rowSelection: false,
            loading: false,
            pagination:{
                hideOnSinglePage:false,
                position:['bottomLeft'],
                responsive:true,// size 未指定时，根据屏幕宽度自动调整尺寸
                current:1,
                pageSize:10,
                pageSizeOptions:['10','20','50'],
                total:0,
                // showTotal:()=>t('base.total') + ` ${table.value.configs.pagination.total} ` + t('base.row')
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        }
    })
    const img_file = ref(null)

    const headerData = ref({
        menu:'menu.FaultCodeMaintenance',
        menu_desc: '',
        week: getWeek().week,
        current_time: getWeek().currentDate,
    })

    const setFormUploadImgData = (form)=>{
        form.formField.forEach(item=>{
            if(item.type == 'uploadImg'){
                item.uploadImgData.title = t('base.uploadImg')
            }
        })
    }
    setFormUploadImgData(addForm)
    setFormUploadImgData(copyAddForm)

    const handle = (type,row)=>{
        let arr = ['sys_org_val','fault_limit','fault_limit_de', 'fault_limit_fr', 'fault_limit_nl', 'fault_limit_et', 'fault_limit_lv', 'fault_limit_lt']
        switch(type){
            case 'add':
                addVisible.value = true
                modalTitle.value = t('base.add')
                operateType.value = 'add'
                addForm.formField.forEach(item=>{
                    item.disabled = false
                })
                resetForm(type)
                addForm.formField.forEach(item=>{
                    if(arr.includes(item.key)){
                        item.showAddBtn = false
                        item.showRemoveBtn = false 
                    }
                })
                getTenantList()
                break;
            case 'edit':
                addVisible.value = true
                modalTitle.value = t('base.edit')
                operateType.value = 'edit'
                rowData.value = row
                resetForm(type)
                getDetail(row)
                addForm.formField.forEach(item=>{
                    if(arr.includes(item.key)){
                        item.showAddBtn = false
                    }
                })
                getTenantList()
                break;
            case 'confirm':
                if(!vaild()) return

                addForm.formField.forEach(item=>{
                    if(item.childKeyArr !== undefined){
                        let str = ''
                        item.childKeyArr.forEach(per=>{
                            str += `**${addForm.formData[per]}`
                        })
                        addForm.formData[item.key] = `${addForm.formData[item.key]}${str}` 
                    }
                }) 
                addFaultCode(operateType.value)
                break;
            case 'link':
                window.open(row.fault_path)
                break;
        }
    }

    const handleSelectChange = (val, key)=>{
        table.value.configs.pagination.current = 1
        getFaultCodeList()
    }

    const handleInputChange = (val, key)=>{
        table.value.configs.pagination.current = 1
        getFaultCodeList()
    }

    // const handleOk = ()=>{
    //     table.value.configs.pagination.current = 1
    //     visible.value = false
    //     getFaultCodeList()
    // }

    // const handleSearch = ()=>{
    //     visible.value = true
    // }

    // 增加输入框
    const handleAddBtnClick = (data)=>{
        let item = addForm.formField.find(i=> i.key == data.key)
        item.num = item.num? item.num + 1 : 1  // 点击增加按钮的次数：表示增加的第n个输入框
        let itemIndex = addForm.formField.findIndex(i=> i.key == data.key) +  item.num // 获取当前哪个字段在新增输入框，得到新增输入框应该插入的位置下标
        addForm.formField.splice(itemIndex, 0, { // 插入新增的输入框
            ...item,
            name_lang: ' ',// 值为空格，占位
            key:`${item.key}_${item.num}`,
            showAddBtn:false, // 新增的输入框 不需要新增按钮
            showRemoveBtn:false, // // 新增的输入框 不需要删除按钮
            isChild:true, // 判断是否为新增的输入框
            childKeyArr:undefined, // 新增的输入框不需要key集合，故设置为undefined
            addonBefore: `${item.num + 1}.`
        })
        addForm.formData[`${item.key}_${item.num}`] = ''
        item.removeBtnDisabled = false
        item.childKeyArr.push(`${item.key}_${item.num}`)
    }

    // 删除输入框
    const handleRemoveBtnClick = (data)=>{
        let item = addForm.formField.find(i=> i.key == data.key)
        let itemIndex = addForm.formField.findIndex(i=> i.key == data.key) + item.num
        addForm.formField.splice(itemIndex, 1)
        item.num = item.num - 1
        if(item.num == 0) item.removeBtnDisabled = true
        item.childKeyArr.splice(item.childKeyArr.length - 1, 1) 
    }

    // 分页
    const handleChangePagination = (config, data)=> {
        table.value.configs.pagination.current = config.current
        table.value.configs.pagination.pageSize = config.pageSize
        getFaultCodeList()
    }

    // 上传图片
    const uploadChange = async (file, fileList, row)=>{
        // console.log(file, fileList,'mmmmm',row)

        okBtnDisabled.value = true
        if(fileList.length > 0){
            img_file.value = fileList[0].originFileObj
            let form = new FormData()
            form.append('file', img_file.value)
            let res = await FaultApi.getInstance().uploadPictures(form)
            if(res.code === 0){
                addForm.formData[row.key] = res.data.download_path
                // console.log(addForm.formData,'ffgg', okBtnDisabled.value)
            }else{
                message.error(res.msg)
            }
        }
        okBtnDisabled.value = false
    }

    // 删除图片
    const uploadRemove = (row)=>{
        img_file.value = null
        addForm.formData[row.key] = ''
    }

    // 检验必填
    const vaild = ()=>{
        let formObj = {}
        addForm.formField.forEach(i=>{
            formObj[i.key] = addForm.formData[i.key]
        })
        addForm.formData = JSON.parse(JSON.stringify(formObj)) 

        let keyArr = [
            'sys_org_val','fault_code','protocol',
            'fault_status','fault_limit', 'fault_measure',
            'fault_status_de','fault_limit_de', 'fault_measure_de',
            'fault_status_fr','fault_limit_fr', 'fault_measure_fr',
            'fault_status_nl','fault_limit_nl', 'fault_measure_nl',
            'fault_status_et','fault_limit_et', 'fault_measure_et',
            'fault_status_lv','fault_limit_lv', 'fault_measure_lv',
            'fault_status_lt','fault_limit_lt', 'fault_measure_lt',
        ]
        let key_img_arr = [
            'fault_measure_img','fault_measure_de_img','fault_measure_fr_img','fault_measure_nl_img',
            'fault_measure_et_img','fault_measure_lv_img','fault_measure_lt_img'
        ]
        for(let key in addForm.formData){
            if(addForm.formData[key] === '' && !key_img_arr.includes(key)){
                if(keyArr.includes(key)){
                    message.error(t(`faultData.${key}`)+ ' ' +t('base.noEmpty'))
                }else{
                    message.error(t('base.hasEmptyItem'))
                }
                
                return false
            }
        }
        return true
    }

    // 截取img标签
    const getImg = (data)=>{
        let reg = /<img/g
        let src = ''
        if(reg.test(data)){
            let str = data 
            let imgReg = /<img.*?(?:>|\/>)/gi
            let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i
            let arr = str.match(imgReg)
        
            arr.forEach(item=>{
                src = item.match(srcReg)[1]
            })
        }
        return src
    }

    const getMeasure = (data)=>{
        let reg = /<img/g
        if(reg.test(data)){
            data = data.split('/>')[1]
        }
        data = data.split('**').filter(i=> i !== '')
        return data
    }

    // 重置表单
    const resetForm = (type)=>{
        // 重置表单字段
        addForm.formField = JSON.parse(JSON.stringify(copyAddForm.formField))
        addForm.formData = JSON.parse(JSON.stringify(copyAddForm.formData))
        
        // console.log(addForm,'addForm')
        // console.log(copyAddForm,'copyAddForm')
        
        // 新增时表单字段数据置空
        if(type == 'add'){
            for(let key in addForm.formData){
                addForm.formData[key] = ''
            }
            img_file.value = null
            addForm.formData.fault_measure_img = ''
            addForm.formData.fault_measure_de_img = ''
            addForm.formData.fault_measure_fr_img = ''
            addForm.formData.fault_measure_nl_img = ''
            addForm.formData.fault_measure_et_img = ''
            addForm.formData.fault_measure_lv_img = ''
            addForm.formData.fault_measure_lt_img = ''
        }
        if(type == 'edit'){
            addForm.formField.forEach(item=>{
                item.disabled = item.key == 'fault_code'
            })
        }
    }
    
    // 获取故障码列表
    const getFaultCodeList = async ()=>{
        let param = {
            fault_code: (fault_code.value || '').trim(),
            sys_org: tenant_id.value,
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true
        let res = await FaultApi.getInstance().getFaultCodeList(param,page_num,page_size)
        if(res.code === 0){
            table.value.data = []
            res.data.records.length > 0 && res.data.records.forEach((item,index) => {
                table.value.data.push({
                    ...item,
                    order_number:index + 1,
                    sys_org_val: item.sys_org,
                    sys_org: item.sys_org == undefined? '-' : tenantOptions.value.find(m=> m.value == item.sys_org).label,
                    protocol_val: item.protocol,
                    protocol: item.protocol == undefined? '-' : item.protocol == 0? 'PLC' : 'CAN',
                    fault_status_de:item.fault_status_de == undefined? '-' : item.fault_status_de,
                    fault_status_fr:item.fault_status_fr == undefined? '-' : item.fault_status_fr,
                    fault_status_nl:item.fault_status_nl == undefined? '-' : item.fault_status_nl,
                    fault_status_et:item.fault_status_et == undefined? '-' : item.fault_status_et,
                    fault_status_lv:item.fault_status_lv == undefined? '-' : item.fault_status_lv,
                    fault_status_lt:item.fault_status_lt == undefined? '-' : item.fault_status_lt,
                    
                    fault_limit:item.fault_limit == undefined? '-' : item.fault_limit.split('**').filter(i=> i !== ''),
                    fault_limit_de:item.fault_limit_de == undefined? '-' : item.fault_limit_de.split('**').filter(i=> i !== ''),
                    fault_limit_fr:item.fault_limit_fr == undefined? '-' : item.fault_limit_fr.split('**').filter(i=> i !== ''),
                    fault_limit_nl:item.fault_limit_nl == undefined? '-' : item.fault_limit_nl.split('**').filter(i=> i !== ''),
                    fault_limit_et:item.fault_limit_et == undefined? '-' : item.fault_limit_et.split('**').filter(i=> i !== ''),
                    fault_limit_lv:item.fault_limit_lv == undefined? '-' : item.fault_limit_lv.split('**').filter(i=> i !== ''),
                    fault_limit_lt:item.fault_limit_lt == undefined? '-' : item.fault_limit_lt.split('**').filter(i=> i !== ''),

                    fault_measure:item.fault_measure == undefined? '-' : getMeasure(item.fault_measure),
                    fault_measure_de:item.fault_measure_de == undefined? '-' : getMeasure(item.fault_measure_de),
                    fault_measure_fr:item.fault_measure_fr == undefined? '-' : getMeasure(item.fault_measure_fr),
                    fault_measure_nl:item.fault_measure_nl == undefined? '-' : getMeasure(item.fault_measure_nl),
                    fault_measure_et:item.fault_measure_et == undefined? '-' : getMeasure(item.fault_measure_et),
                    fault_measure_lv:item.fault_measure_lv == undefined? '-' : getMeasure(item.fault_measure_lv),
                    fault_measure_lt:item.fault_measure_lt == undefined? '-' : getMeasure(item.fault_measure_lt),

                    fault_measure_img: item.fault_measure == undefined? '' : getImg(item.fault_measure),
                    fault_measure_de_img: item.fault_measure_de == undefined? '' : getImg(item.fault_measure_de),
                    fault_measure_fr_img: item.fault_measure_fr == undefined? '' : getImg(item.fault_measure_fr),
                    fault_measure_nl_img: item.fault_measure_nl == undefined? '' : getImg(item.fault_measure_nl),
                    fault_measure_et_img: item.fault_measure_et == undefined? '' : getImg(item.fault_measure_et),
                    fault_measure_lv_img: item.fault_measure_lv == undefined? '' : getImg(item.fault_measure_lv),
                    fault_measure_lt_img: item.fault_measure_lt == undefined? '' : getImg(item.fault_measure_lt),

                    showMoreText:false,
                })
            })
            console.log(table.value,'vvv')
            table.value.configs.pagination.total = res.data.total
            table.value.configs.loading = false
        }else{
            message.error(res.msg)
        }
    }

    // 新增/编辑 故障码
    const addFaultCode = async ()=>{
        let param = {
            sys_org: addForm.formData.sys_org_val,
            fault_code: addForm.formData.fault_code,
            protocol: addForm.formData.protocol,
            fault_limit: addForm.formData.fault_limit,
            fault_limit_de: addForm.formData.fault_limit_de,
            fault_limit_fr: addForm.formData.fault_limit_fr,
            fault_limit_nl: addForm.formData.fault_limit_nl,
            fault_limit_et: addForm.formData.fault_limit_et,
            fault_limit_lv: addForm.formData.fault_limit_lv,
            fault_limit_lt: addForm.formData.fault_limit_lt,
            fault_status: addForm.formData.fault_status,
            fault_status_de: addForm.formData.fault_status_de,
            fault_status_fr: addForm.formData.fault_status_fr,
            fault_status_nl: addForm.formData.fault_status_nl,
            fault_status_et: addForm.formData.fault_status_et,
            fault_status_lv: addForm.formData.fault_status_lv,
            fault_status_lt: addForm.formData.fault_status_lt,
            fault_measure: addForm.formData.fault_measure,
            fault_measure_de: addForm.formData.fault_measure_de,
            fault_measure_fr:addForm.formData.fault_measure_fr,
            fault_measure_nl:addForm.formData.fault_measure_nl,
            fault_measure_et:addForm.formData.fault_measure_et,
            fault_measure_lv:addForm.formData.fault_measure_lv,
            fault_measure_lt:addForm.formData.fault_measure_lt,
        }
        if(addForm.formData.fault_measure_img){
            let img = `<img src='${addForm.formData.fault_measure_img}' width='95%' height='220' style='vertical-align:middle;'/>`
            param.fault_measure = `${img}**${addForm.formData.fault_measure}`
        }
        if(addForm.formData.fault_measure_de_img){
            let img = `<img src='${addForm.formData.fault_measure_de_img}' width='95%' height='220' style='vertical-align:middle;'/>`
            param.fault_measure_de = `${img}**${addForm.formData.fault_measure_de}`
        }
        if(addForm.formData.fault_measure_fr_img){
            let img = `<img src='${addForm.formData.fault_measure_fr_img}' width='95%' height='220' style='vertical-align:middle;'/>`
            param.fault_measure_fr = `${img}**${addForm.formData.fault_measure_fr}`
        }
        if(addForm.formData.fault_measure_nl_img){
            let img = `<img src='${addForm.formData.fault_measure_nl_img}' width='95%' height='220' style='vertical-align:middle;'/>`
            param.fault_measure_nl = `${img}**${addForm.formData.fault_measure_nl}`
        }
        if(addForm.formData.fault_measure_et_img){
            let img = `<img src='${addForm.formData.fault_measure_et_img}' width='95%' height='220' style='vertical-align:middle;'/>`
            param.fault_measure_et = `${img}**${addForm.formData.fault_measure_et}`
        }
        if(addForm.formData.fault_measure_lv_img){
            let img = `<img src='${addForm.formData.fault_measure_lv_img}' width='95%' height='220' style='vertical-align:middle;'/>`
            param.fault_measure_lv = `${img}**${addForm.formData.fault_measure_lv}`
        }
        if(addForm.formData.fault_measure_lt_img){
            let img = `<img src='${addForm.formData.fault_measure_lt_img}' width='95%' height='220' style='vertical-align:middle;'/>`
            param.fault_measure_lt = `${img}**${addForm.formData.fault_measure_lt}`
        }

        console.log(param,'paramppp')

        let res = operateType.value == 'add'
                ? await FaultApi.getInstance().addFaultCode(param)
                : await FaultApi.getInstance().editFaultCode(rowData.value.id,param)
        if(res.code === 0){
            message.success(operateType.value == 'add'? t('base.addSuccessMsg') : t('base.editSuccessMsg'))
            addVisible.value = false
            getFaultCodeList()
        }else{
            message.error(res.msg)
        }
    }

    // 获取详情
    const getDetail = (row)=>{
        let arr = [
            'sys_org_val','fault_code','protocol',
            'fault_status','fault_status_de','fault_status_fr','fault_status_nl',
            'fault_status_et','fault_status_lv','fault_status_lt',
            'fault_measure_img','fault_measure_de_img','fault_measure_fr_img','fault_measure_nl_img',
            'fault_measure_et_img','fault_measure_lv_img','fault_measure_lt_img'
        ]
        // console.log(row,'www')
        for(let key in addForm.formData){
            if(arr.includes(key)){
                addForm.formData[key] = row[key] == '-'? '' : row[key]
                if(key == 'protocol') addForm.formData.protocol = `${row.protocol_val}`
                addForm.formField.forEach(item=>{
                    if(item.key == key && item.type == 'uploadImg' && row[key] !== ''){
                        item.uploadImgData.imgList = [{
                            url:row[key]
                        }]
                    }
                })
            }else if(row[key] && row[key].length == 1){
                addForm.formData[key] = row[key][0] == '-'? '' : row[key][0]
            }else if(row[key] && row[key].length > 1){
                let item = addForm.formField.find(i=> i.key == key)
                // console.log(item,'iiiggg')
                addForm.formData[key] = row[key][0]    
                for(let i=1; i<row[key].length; i++){ // 循环插入输入框
                    let val = row[key][i]
                    item.num = item.num? item.num + 1 : 1 
                    let itemIndex = addForm.formField.findIndex(i=> i.key == key) + item.num
                    addForm.formField.splice(itemIndex, 0, {
                        ...item,
                        name_lang: ' ',// 值为空格，占位
                        key:`${item.key}_${item.num}`,
                        showAddBtn:false,
                        showRemoveBtn:false,
                        isChild:true,
                        childKeyArr:undefined, 
                        addonBefore: `${item.num + 1}.`,
                        operateType:'edit'
                    })
                    item.removeBtnDisabled = false
                    item.childKeyArr.push(`${item.key}_${item.num}`)
                    addForm.formData[`${item.key}_${item.num}`] = val
                }
            }
        }
    }

    // 获取租户列表
    const getTenantList = async()=>{
        let param = {
            limit_size: 100,
        }
        let res = await AdvancedFunApi.getInstance().getAllTenant2(param)
        if(res.code === 0){
            let addForm_tenant = addForm.formField.find(item=> item.key == 'sys_org_val')  
            addForm_tenant.options = []

            addForm_tenant.options = res.data.filter(item=> item.tenant_id == 0 || item.tenant_id == 1).map(item => ({
                label: item.tenant_name,
                value: item.tenant_id,
            }))

            tenantOptions.value = res.data.filter(item=> item.tenant_id == 0 || item.tenant_id == 1).map(item => ({
                label: item.tenant_name,
                value: item.tenant_id,
            }))
            tenantOptions.value.unshift({
                label: t('access.allTenant'),
                value: null,
            })
        }
    }

    
    onMounted(async ()=>{
        await getTenantList()
        getFaultCodeList()
        
    })

</script>

<style lang="scss" scoped>
::v-deep .ant-col.ant-col-14.ant-form-item-control {
    width: 800px;
}

::v-deep .page_header .week{
    margin-top: -55px;
    transform: translateY(8px);
}
::v-deep .page_header .admin_email{
    margin-top: -55px;
    transform: translateY(18px);
}

.fault_path{
    text-decoration: underline;
    color: #1226aa !important;
    cursor: pointer;
}
a{
    color: #1226aa;
}

.fault_measure_ul{
    position: relative;
    margin-bottom: 0;
    height: 22px;
    overflow: hidden;
}

.fault_measure_ul_more{
    position: relative;
    margin-bottom: 0;
    height: auto;
}

.downCircle{
    position: absolute;
    left: 0;
    top:50%;
    margin-top: -5px;
    color:#1226aa;
    cursor: pointer;
}

.editBtn{
    background: #1226aa;
}

::v-deep .ant-modal-footer{
    text-align: center;
}

::v-deep .ant-table-cell {
    text-align: left !important;
}

::v-deep .uploadImg{
    margin-left: 200px;
}

::v-deep .noLabel{
    .ant-form-item-label > label::after{
        display: none;
    }
}

::v-deep .ant-table-thead > tr > th, 
::v-deep .ant-table-tbody > tr > td, 
::v-deep .ant-table tfoot > tr > th, 
::v-deep .ant-table tfoot > tr > td{
    padding: 10px 16px;
}

// .ant-btn-primary.ant-btn-dangerous{
//     background: #ff4d4f;
// }


</style>